import React from 'react'
import './mouse.component.css'

export default class MouseComponent extends React.Component {
    constructor(){
        super();
        window.__forceSmoothScrollPolyfill__ = true;
    }

    goto(){
        setTimeout(() => {
            document.querySelector('#goToAbout').scrollIntoView({  behavior: 'smooth', block: "start"});
        }, 100); 
    }

    render(){
        
        return (
            <div className="scroll-downs" onClick={() => this.goto()}>
                <div className="mousey">
                    <div className="scroller"></div>
                </div>
            </div>
        )
    }
}



// WEBPACK FOOTER //
// ./src/components/mouse/mouse.component.js